/**
 * Whether the person has asked their device for less motion.
 *
 * Its own file because a component file that also exports a hook breaks fast
 * refresh, and eslint is right to say so. Read lazily rather than set in an
 * effect: a synchronous setState there triggers a cascading render, and the
 * answer is available at first paint.
 *
 * @since 1.0.0 signfeel
 */
import { useEffect, useState } from 'react';

export function usePrefersReducedMotion(): boolean {
    // `matchMedia` is absent where there is no screen at all (jsdom, which the
    // Day Book's tests render in): no screen has asked for less motion.
    const [reduced, setReduced] = useState(
        () => typeof window !== 'undefined' && typeof window.matchMedia === 'function'
            && window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    );
    useEffect(() => {
        if (typeof window.matchMedia !== 'function') return;
        const q = window.matchMedia('(prefers-reduced-motion: reduce)');
        const on = () => setReduced(q.matches);
        q.addEventListener('change', on);
        return () => q.removeEventListener('change', on);
    }, []);
    return reduced;
}
